import { safeJson } from "src/app/helpers/Index";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { Attendance } from "src/app/interfaces/Index";
import { FixtureService } from "src/app/services/Index";
import "./ScoreboardAttendance.css";

type Props = {};
type State = {
	attendance: Attendance
};
export class ScoreboardAttendance extends React.Component<Props, State> {
	
	constructor(props: Props) {
		super(props);
		this.state = {attendance: new Attendance};
	}

	componentDidMount() {
		this.getAttendance();
	}
	
	render() {
		return (
			<div id="scoreboard-wrapper" style={{textAlign: "center", width:576, height:432}}>
				<h1>ATTENDANCE</h1>
				<h2 className="attendance-amount">{this.state.attendance.matchAttendance}</h2>
				<h2>({this.state.attendance.matchAwayAttendance} Away)</h2>
				<Row style={{width:576,height:75, backgroundColor:"white",position:"absolute",left:12, bottom:0}}>
					<Col><img src={"https://sufc.blob.core.windows.net/uploads/debug.jpg"} height="55" style={{marginLeft:-12,marginTop:10}}/></Col>
					</Row>				
			</div>
		);
	}

	async getAttendance(){
		const res = await safeJson(FixtureService.getAttendance());
		if (res && res.error) {
		}
		if (res) this.setState({attendance: res});
	}
}